'use strict';

var _plugin = require('./plugin');
var _plugin2 = _interopRequireDefault(_plugin);
var _defaultConfig = require('./defaultConfig');
var _defaultConfig2 = _interopRequireDefault(_defaultConfig);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
module.exports = _plugin2.default;
module.exports.default = _plugin2.default;
module.exports.defaultConfig = _defaultConfig2.default;